import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';
import { LoadingState } from '../LoadingState';
import { AppLayout } from './AppLayout';
import { MarketingFooter, MarketingNav } from './MarketingChrome';

/**
 * Layout of the public /demo page, which both audiences use: a signed-in user gets it inside the
 * app shell (sidebar, breadcrumbs), a visitor gets the marketing navbar and footer. The Razor page
 * makes the same choice of _Layout or _LandingLayout.
 *
 * An account that must change its password gets the marketing chrome: its sidebar would be full
 * of links RequireAuth sends straight back to /change-password.
 */
export function DemoShell() {
  const { isAuthenticated, initialising, user } = useAuth();

  if (initialising) {
    return (
      <div className="d-flex align-items-center justify-content-center min-vh-100">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading</span>
        </div>
      </div>
    );
  }

  if (isAuthenticated && !user?.mustChangePassword) return <AppLayout />;

  return (
    <div className="landing-body">
      <MarketingNav />
      <main className="container demo-public-shell">
        <Suspense fallback={<LoadingState />}>
          <Outlet />
        </Suspense>
      </main>
      <MarketingFooter />
    </div>
  );
}
